import Tenant from "./Tenant";
import ISiteInfo from "../responses/ISiteInfo";

export default class Site {
  constructor(
    public id: number,
    public tenant: Tenant,
    public code: string,
    public name: string,
    public info: ISiteInfo
  ) {
  }
}
